module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "executiveAdvisoryBoard"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Executive Advisory Board")]), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, _vm._l((_vm.board), function(boardMember) {
    return _c('div', [_c('h5', {
      domProps: {
        "innerHTML": _vm._s(boardMember.name)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(boardMember.organization)
      }
    })])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f691b3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurTeam/ExecutiveAdvisoryBoard.vue
// module id = 330
// module chunks = 1